import { render, staticRenderFns } from "./CountdownProduct.vue?vue&type=template&id=3ebc8cda&scoped=true&"
import script from "./CountdownProduct.vue?vue&type=script&lang=js&"
export * from "./CountdownProduct.vue?vue&type=script&lang=js&"
import style0 from "./CountdownProduct.vue?vue&type=style&index=0&id=3ebc8cda&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebc8cda",
  null
  
)

export default component.exports